import api from 'shared/api';

export const getBundleLicenses = (bundleLicenseID) =>
  api.get(
    `/api/v1/licenses/?limit=1000&offset=0&bundle_license=${bundleLicenseID}`,
  );
